import MDBox from "components/MDBox";
import Dialog from "@mui/material/Dialog";
import FormLabel from '@mui/material/FormLabel';
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MDButton from "components/MDButton";
import React, { useState, useEffect } from "react";
import MDBackdrop from "components/MDBackdrop";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { Checkbox, Col, Row } from 'antd';
import { useSnackbar } from "notistack";
import PopAddContact from "./PopAddContact";
import { useMaterialUIController } from "context";
import theme from "assets/theme";
import services from './components/Services';
import { CloseOutlined } from '@ant-design/icons';
import { Button as AntButton, Card, Form, Input, InputNumber, Radio, Select, DatePicker } from 'antd';
import { allowOnlyAlphanumeric } from "utils/Constant";
import { allowOnlyAlphanumericAndSpace } from "utils/Constant";
import dayjs from "dayjs";

const { Option } = Select;

function PopAddLocation(props) {
    const [form] = Form.useForm();
    const [isDisabled, setIsDisabled] = useState(false);
    const [isBackdrop, setIsBackdrop] = useState(false);
    const { onClose } = props;
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const { sidenavColor } = controller;
    const { enqueueSnackbar } = useSnackbar();
    const [formValues, setFormValues] = useState({
        chargerInfo: [{}],
    });
 

    const onChange = (checkedValues) => {
        setValues((prevValues) => ({
            ...prevValues,
            facilities: checkedValues,
        }));
    };

    const handleConnectorChange = (value, index) => {
        const count = value || 0;


        const generatedConnectors = Array.from({ length: count }, (_, i) => ({
            connectorId: i + 1,
        }));


        const currentChargerInfo = form.getFieldValue('chargerInfo') || [];


        const updatedCharger = {
            ...currentChargerInfo[index],
            connectors: generatedConnectors,
        };


        const updatedChargerInfo = [...currentChargerInfo];
        updatedChargerInfo[index] = updatedCharger;


        form.setFieldsValue({ chargerInfo: updatedChargerInfo });

    };
    const [values, setValues] = useState(props.value);

    const reset = (event) => {
        event.preventDefault();
        form.resetFields();
        setFormValues([{}]);
        setValues(props.value);
    }
    const handleClose = () => {
        onClose(false);
    };
    console.log("Values", values);
    const pop = () => {

        values.chargerInfo = (values.chargerInfo || []).map((charger) => ({
            ...charger,
            onboardingDate: charger.onboardingDate
              ? dayjs(charger.onboardingDate).format("YYYY-MM-DD")
              : null,
          }));
          
        const validChargerInfo = (values.chargerInfo || []).filter(charger => charger != null);
        values.chargerInfo = validChargerInfo;

        if (validChargerInfo.length === 0) {
            return enqueueSnackbar('Please add at least one charger!', { variant: 'error' });
        }

        for (const charger of validChargerInfo) {
            if (!charger.name || !charger.powerOutput || !charger.type || !charger.subtype || !charger.amount) {
                return enqueueSnackbar('Please fill all the details for each charger!', { variant: 'error' });
            }
            if (!allowOnlyAlphanumeric(charger.name)) {
                return enqueueSnackbar('Charger ID can only contain letters and numbers!', { variant: 'error' });
            }
            if (!allowOnlyAlphanumericAndSpace(charger.chargerName)) {
                return enqueueSnackbar('Charger Name can only contain letters, numbers and spaces!', { variant: 'error' });
            }
        }
        if (!values.facilities || !values.facilities.length) {
            return enqueueSnackbar('At least one facility is required!', { variant: 'error' });
        }


        setIsBackdrop(false);
        onClose(false);
        setIsDisabled(!isDisabled)
    };

    console.log("length",values.slots.length)
    const back = () => {
        setIsBackdrop(false);
        onClose(false);
        props.onStateChange(true);
    };
    useEffect(() => {
        setValues((prevValues) => ({
            ...prevValues,
            chargerInfo: formValues.chargerInfo,
        }));
    }, [formValues]);
    useEffect(() => {
        setValues(props.value);
    }, [props.value]);

    const selectAfter = (
        <Select defaultValue="AED" style={{ width: 60 }}>
            <Option value="AED">د.إ</Option>
            <Option value="INR">&#8377;</Option>
            <Option value="USD">$</Option>
            <Option value="EUR">€</Option>
            <Option value="GBP">£</Option>
            <Option value="CNY">¥</Option>
        </Select>
    );
    const handleTypeChange = (key, e) => {
        const value = e.target.value;
        const chargerInfo = form.getFieldValue('chargerInfo') || [];
        const updatedChargerInfo = chargerInfo.map((info, index) => {
            if (index === key) {
                return {
                    ...info,
                    type: value,
                    subtype: value === "AC" ? "CCS2" : "Type6",
                };
            }
            return info;
        });

        form.setFieldsValue({ chargerInfo: updatedChargerInfo });
    };
    return (
        <>

            <MDBackdrop isBackdrop={isBackdrop} />
            <Dialog open={props.isDialog} onClose={handleClose} fullWidth={false}   // stop stretching
                PaperProps={{
                    sx: {
                        width: 1000,     // exact width (adjust if needed)
                        borderRadius: "12px",
                    },
                }}>
                <DialogTitle style={darkMode ? { backgroundColor: "#202940", color: "#ffffff", display: "flex", alignItems: "center", justifyContent: "space-between" } : { theme, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <IconButton aria-label="delete" onClick={back} style={darkMode ? { color: "#ffffff" } : theme}>
                        <ArrowBackIcon />
                    </IconButton>
                    Charger information
                    <IconButton aria-label="delete" onClick={handleClose} style={darkMode ? { color: "#ffffff" } : theme}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent style={darkMode ? { backgroundColor: "#202940", color: "#ffffff" } : theme}>
                    <MDBox pt={0} pb={0} px={3}>
                        <MDBox pt={0}>
                        </MDBox>

                        <MDBox p={2} component="form" role="form">
                            <MDBox p={1}>
                                <Form
                                    labelCol={{
                                        span: 6,
                                    }}
                                    wrapperCol={{
                                        span: 18,
                                    }}
                                    form={form}
                                    name="dynamic_form_complex"
                                    style={{
                                        maxWidth: 600,
                                    }}
                                    autoComplete="off"
                                    initialValues={{
                                        chargerInfo: [{}],
                                    }}
                                    onValuesChange={(changedValues, allValues) => {
                                        setFormValues(allValues);
                                    }}
                                >
                                    <Form.List name="chargerInfo">
                                        {(fields, { add, remove }) => (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    rowGap: 16,
                                                    flexDirection: 'column',
                                                }}
                                            >
                                                {fields.map((field) => (
                                                    <Card
                                                        size="small"
                                                        title={`Charger ${field.name + 1}`}
                                                        key={field.key}
                                                        extra={
                                                            fields.length > 1 && <CloseOutlined
                                                                onClick={() => {
                                                                    remove(field.name);
                                                                }}
                                                            />
                                                        }
                                                    >
                                                        <Form.Item label="Charger ID" name={[field.name, 'name']}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'Please Enter a value',
                                                                },
                                                                {
                                                                    pattern: /^[a-zA-Z0-9]+$/,
                                                                    message: "Only letters and numbers are allowed (no spaces or special characters)",
                                                                },
                                                            ]}
                                                        >
                                                            <Input variant="filled"
                                                                onChange={(e) => {
                                                                    e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
                                                                }}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item label="Charger Name" name={[field.name, 'chargerName']}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'Please Enter a value',
                                                                },
                                                                {
                                                                    pattern: /^[a-zA-Z0-9 ]+$/,
                                                                    message: "Only letters, numbers, and spaces are allowed",
                                                                },
                                                            ]}

                                                        >
                                                            <Input variant="filled"
                                                                onChange={(e) => {
                                                                    e.target.value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, "");
                                                                }}
                                                            />
                                                        </Form.Item>
                                                        <Form.Item label="Power Output" name={[field.name, 'powerOutput']} labelCol={{ xs: 24, sm: 12, md: 8 }}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'Please Enter a value',
                                                                },
                                                            ]}
                                                        >
                                                            <InputNumber addonAfter="kW" variant="filled" />
                                                        </Form.Item>
                                                        <Form.Item label="Cost Per Unit" name={[field.name, 'amount']} labelCol={{ xs: 24, sm: 12, md: 8 }}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'Please Enter a value',
                                                                },
                                                            ]}
                                                        >
                                                            <InputNumber
                                                                addonBefore={selectAfter}
                                                                variant="filled" />
                                                        </Form.Item>
                                                        <Form.Item label="Charger Type" name={[field.name, 'type']} labelCol={{ xs: 24, sm: 12, md: 8 }} rules={[
                                                            {
                                                                required: true,
                                                                message: 'Select something!',
                                                            },
                                                        ]}
                                                        >
                                                            <Radio.Group onChange={(e) => handleTypeChange(field.name, e)}>
                                                                <Radio value="AC"> AC </Radio>
                                                                <Radio value="DC"> DC </Radio>
                                                            </Radio.Group>
                                                        </Form.Item>
                                                        {form.getFieldValue(['chargerInfo', field.name, 'type']) && (<Form.Item label="Connector Type" name={[field.name, 'subtype']} labelCol={{ xs: 24, sm: 12, md: 8 }} rules={[
                                                            {
                                                                required: true,
                                                                message: 'Select something!',
                                                            },
                                                        ]}
                                                            initialValue="CCS2"
                                                        >
                                                            <Radio.Group>
                                                                <Radio value="CCS2"> CCS2 </Radio>
                                                                <Radio value="Type6" disabled={form.getFieldValue(['chargerInfo', field.name, 'type']) === "AC"}> Type6 </Radio>
                                                                <Radio value="Type2" disabled={form.getFieldValue(['chargerInfo', field.name, 'type']) === "DC"}> Type2 </Radio>
                                                                <Radio value="Type7" disabled={form.getFieldValue(['chargerInfo', field.name, 'type']) === "AC"}> Type7 </Radio>
                                                            </Radio.Group>
                                                        </Form.Item>)}
                                                        <Form.Item label="No of Connectors" name={[field.name, 'NoOfconnector']} labelCol={{ xs: 24, sm: 12, md: 8 }}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'Please Enter a value',
                                                                },
                                                                {
                                                                    type: 'number',
                                                                    min: 1,
                                                                    max: 8,
                                                                    message: 'Value must be between 1 and 8',
                                                                },
                                                            ]}
                                                        >
                                                            <InputNumber
                                                                variant="filled"
                                                                style={{ width: "100%" }}
                                                                onChange={(value) => handleConnectorChange(value, field.name)}
                                                            />
                                                        </Form.Item>
                                                        <Form.Item
                                                            label="Onboarding Date"
                                                            name={[field.name, "onboardingDate"]}
                                                            labelCol={{ span: 8 }}          // fixes label cut issue
                                                            wrapperCol={{ span: 12 }}       // reduces input width
                                                            rules={[
                                                                { required: true, message: "Onboarding Date is required" },
                                                            ]}
                                                        >
                                                            <DatePicker
                                                                format="YYYY-MM-DD"
                                                                style={{ width: "100%" }}
                                                                disabledDate={(current) => current && current > new Date()}
                                                            />
                                                        </Form.Item>

                                                    </Card>
                                                ))}

                                                <AntButton type="dashed" onClick={() => add()} block>
                                                    + Add Charger
                                                </AntButton>
                                            </div>
                                        )}
                                    </Form.List>
                                </Form>
                            </MDBox>
                            <MDBox p={1}>
                                <FormLabel >Facilities</FormLabel>
                            </MDBox>
                            <MDBox p={1}>
                                <Checkbox.Group
                                    style={{
                                        width: '100%',
                                    }}
                                    onChange={onChange}
                                    value={values.facilities}
                                >
                                    <Row gutter={16}>
                                        {services.map((service, index) => (
                                            <Col key={index} xs={24} sm={12} md={8}>
                                                <Checkbox value={service}>{service.name}</Checkbox>
                                            </Col>
                                        ))}
                                    </Row>
                                </Checkbox.Group>
                            </MDBox>
                        </MDBox>
                    </MDBox>
                </DialogContent>
                <DialogActions style={darkMode ? { backgroundColor: "#202940", justifyContent: "space-evenly", color: "#ffffff" } : { theme, justifyContent: "space-evenly" }}>

                    <MDButton variant="gradient" color={sidenavColor} onClick={reset}>
                        Reset
                    </MDButton>
                    <MDButton variant="gradient" color={sidenavColor}
                        onClick={pop}
                    >
                        NEXT
                    </MDButton>
                </DialogActions>
            </Dialog>
            <PopAddContact
                isDialog={isDisabled}
                onClose={setIsDisabled}
                value={values}
                onStateChange={props.onStateChange1}
                chargerInfo={formValues.chargerInfo}
            />
        </>
    );
}

export default PopAddLocation;